export default {
    formatWideObj(obj){
        return `${obj.minAmount}万(${obj.minIsContain==1?'含':'不含'})-${obj.maxAmount}万(${obj.maxIsContain==1?'含':'不含'})`
    },
    objToDisplay(obj){
        return `${obj.minAmount/10000}万(${obj.minIsContain==1?'含':'不含'})-${obj.maxAmount/10000}万(${obj.maxIsContain==1?'含':'不含'})`
    },
    divideGroup(array, key) {
        //分组
        //收集key
        let result = [],
          keyArr = [],
          reciveArr = [];
        array.map((item) => {
          if (keyArr.indexOf(item[key]) == -1) {
            keyArr.push(item[key]);
          }
        });
  
        //筛选不同代码产品
        keyArr.map((ele) => {
          let arr = [];
          array.map((item) => {
            if (ele == item[key]) {
              arr.push(item);
            }
          });
          reciveArr.push(arr);
        });
        return reciveArr;
      },
}